import { PropType } from '@nuxtjs/composition-api'
import { DynamicFormTelephoneCountry } from '~/models/dynamic-form/schema'

export const DYNAMIC_FORM_FIELD_PROPS: any = {
  name: {
    type: String,
    default: ''
  },
  fieldError: {
    type: String,
    default: null
  },
  fieldValue: {
    type: [String, Number, Object, Boolean, Array],
    default: null
  },
  min: {
    type: [Number, String],
    required: false
  },
  max: {
    type: [Number, String],
    required: false
  },
  isRequired: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  countries: {
    type: Array as PropType<DynamicFormTelephoneCountry[]>,
    default() {
      return []
    }
  },
  social: {
    type: Object,
    default: null
  },
  fieldValues: {
    type: Object,
    default() {
      return {}
    }
  },
  options: {
    type: Array,
    default() {
      return []
    }
  },
  context: {
    type: String,
    required: false,
    default: ''
  }
}
